/**
 * People Leave module tour — page-level quick start.
 */

export const PEOPLE_LEAVE_TOUR_ID = "people-leave-v1";

export const PEOPLE_LEAVE_TOUR_STEPS = [
  {
    id: "banner",
    route: "/people/leave",
    selector: "[data-tour='leave-mode']",
    title: "Live leave data",
    description:
      "When you have leave permissions, balances and requests are live. Status messages here tell you if something needs attention.",
    placement: "bottom",
  },
  {
    id: "balances",
    route: "/people/leave",
    selector: "[data-tour='leave-balances']",
    title: "Your balances",
    description:
      "Available is what you can still request. Booked is pending (informational only — it does not reduce Available). Taken is leave that has already started.",
    placement: "bottom",
  },
  {
    id: "form",
    route: "/people/leave",
    selector: "[data-tour='leave-form']",
    title: "Request leave",
    description:
      "Choose the leave type, pick working days on the calendar, then add handover or documents only when that type requires them. Policy issues show before you submit.",
    placement: "right",
  },
];
